import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./BottomCart.css";

const BottomCart = ({ cart }) => {

  const navigate = useNavigate();
  const location = useLocation();
  if (cart.length === 0 || location.pathname === "/payment") {
    return null;
  }

  const totalAmount = cart.reduce((total, item) => total + item.price, 0);

  return (
    <div className="bottom-cart">
      <div className="cart-info">
        <span>{cart.length} items</span>
        <strong>₹{totalAmount}</strong>
      </div>

      <button
        className="view-cart-btn"
        onClick={() => navigate("/payment")}
      >
        VIEW CART →
      </button>
    </div>
  );
};

export default BottomCart;